import React, {cloneElement, Children, Component} from 'react'
import PropTypes from 'prop-types'
import { speed } from 'jquery';



let longestSide = window.innerWidth > window.innerHeight ? window.innerWidth : window.innerHeight;
let shortestSide = window.innerWidth > window.innerHeight ? window.innerHeight : window.innerWidth;
let screenSize = [window.innerWidth, window.innerHeight];

const setScreenOrientation = () =>{
  longestSide = window.innerWidth > window.innerHeight ? window.innerWidth : window.innerHeight;
  shortestSide = window.innerWidth > window.innerHeight ? window.innerHeight : window.innerWidth;
  screenSize = [window.innerWidth, window.innerHeight];

  if(window.mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
    startLeftOffset = -25;
    barOffset = 10;
    screenSize = [longestSide * 0.5625, longestSide];
    imageSize = [longestSide * 0.84 * 1.777778, longestSide * 0.84];
  } else {
    imageSize = [longestSide, longestSide * 0.5625];
    barOffset = 0;
    startLeftOffset = 0;
  }
}

window.addEventListener("resize", setScreenOrientation);

// TODO move this to utils
window.mobileAndTabletCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};
let imageSize = [longestSide, longestSide * 0.5625];
let barOffset = 0;
let startLeftOffset = 0;
if(window.mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
  startLeftOffset = -25;
  barOffset = 10;
  screenSize = [longestSide * 0.5625, longestSide];
  imageSize = [longestSide * 0.84 * 1.777778, longestSide * 0.84];
}
class Rotation extends Component { 

  hovered = false

  state = {
    current: 0,
    acc: 0,
    speed: 0,
    fr: 0.92,
    targetDegree: 0,
    autoPlay: false,
    updateId: {},
    zoom: 1,
    targetZoom: 1,
    topOffset: 0, // 0 for simpler math, needs +10% of the bar size
    targetTopOffset: 0, // 0 for simpler math, needs +10% of the bar size
    leftOffset: startLeftOffset, //screenSize[0]/2,
    targetLeftOffset: startLeftOffset,//screenSize[0]/2,
    fpsInterval: 1000 / 5 // 5 fps
  }
  update(){
    
    if(!this._isMounted)
    {
        return; 
    }
    
    requestAnimationFrame(() => this.update());
    
    this.now = Date.now();
    this.elapsed = this.now - this.then;

    
    this.then = this.now - (this.elapsed % this.state.fpsInterval)

    if(this.elapsed > this.state.fpsInterval){
      if(this.state.autoPlay){          
          
          if(Math.abs(this.state.speed) === 0 || 
          Math.abs(this.state.current * 144 / (this.props.children.length || 1) + this.state.speed - this.state.targetDegree) <= Math.min(24, (this.props.is180 ? 0.5 : 1) * 144 / (this.props.children.length || 1))){
            this.setState({
              autoPlay: false,
              speed: 0
            })
            this.props.onRotationEnded();
          }
      } else {
        this.setState(prevState => ({ speed: prevState.speed * prevState.fr }))     
      }      
    }
    if(this.elapsed > this.state.fpsInterval){
      this.setCurrentFrame((this.state.current + Math.round(this.state.speed)))
    } 

    if(Math.abs(this.state.zoom - this.state.targetZoom) > 0.01 || 
      Math.abs(this.state.leftOffset - this.state.targetLeftOffset) > 0.01 || 
      Math.abs(this.state.topOffset - this.state.targetTopOffset) > 0.01){
      this.setState(prevState => ({
        zoom: prevState.zoom + (this.state.targetZoom - prevState.zoom) / 10,
        leftOffset: prevState.leftOffset + (this.state.targetLeftOffset - prevState.leftOffset) / 10,
        topOffset: prevState.topOffset + (this.state.targetTopOffset - prevState.topOffset) / 10
      }))

      if(this.props.notifyZoomAndOffsets){
        this.props.notifyZoomAndOffsets(this.state.zoom, this.state.leftOffset, this.state.topOffset)
      }
    } 

  }

  moveTo(deg){

    if(!this._isMounted){
      return;
    }
    
    this.setState({
      autoPlay: true,
      targetDegree: deg
    }, 
    () => {
      this.setState(prevState => ({
        acc: prevState.acc * prevState.fr,
        speed: Math.abs(this.state.targetDegree - Math.round(this.state.current)) <= Math.abs(this.state.targetDegree - 144 - Math.round(this.state.current)) ?
          Math.sign(prevState.targetDegree - Math.round(prevState.current))
          :
          Math.sign(this.state.targetDegree - 144 - Math.round(this.state.current))
      })) 
    })
  }

  componentDidMount () {

    this.handleUpdateViewer()

    this._isMounted = true;

    let canvas = document.getElementById('canvas-content') 
    canvas.addEventListener('touchstart', this.touchStart);
    canvas.addEventListener('touchmove', this.touchMove);
    canvas.addEventListener('touchend', this.touchEnd);
    canvas.addEventListener('mousedown', this.touchStart);
    canvas.addEventListener('mousemove', this.touchMove);
    document.addEventListener('mouseup', this.touchEnd, false)
    
    this.then = Date.now();
    this.now = 0;
    this.elapsed = 0;

    var updateId = requestAnimationFrame(() => this.update());
    this.setState({updateId: updateId})

    this.touchCenter = [0,0]
    this.newTouchCenter = [0,0]    

    this.props.notifyZoomAndOffsets(1, startLeftOffset, 0)
  }

  

  componentDidUpdate(prevProps){

    //this.handleUpdateViewer()

    if(!this._isMounted){
      return;
    }
    
    if(prevProps.children.length < this.props.children.length){
      
      switch(this.props.children.length){
        case 6:
          this.setState({
            fr: 0.8,
            fpsInterval: 1000 / 6
          })
        break;
        case 12:
          this.setState({
            fr: 0.7,
            fpsInterval: 1000 / 5
          })
          break;
        case 24:
          this.setState({
            fr: 0.74,
            fpsInterval: 1000 / 24
          })
          break;
        case 36:
            this.setState({
              fr: 0.86,
              fpsInterval: 1000 / 30
            })
            break;
        case 72:
          this.setState({
            fr: 0.86,
            fpsInterval: 1000 / 30
          })
          break;
        case 144:
          this.setState({
            fr: 0.92,
            fpsInterval: 1000 / 60
          })
          break;
      }
      
      if( prevProps.children.length > 0 )
      {
        
        this.setState({
          current: Math.floor(this.state.current / prevProps.children.length * this.props.children.length)
        })
      } else {
        // routine for middle frame start changing, possibly deprecated.
        /*if(this.props.is180 && this.props.initFrame !== undefined && this.props.initFrame !== -1){
          //if(this.props.children[0].props.src.indexOf('Huerta') === -1){
          console.log('[set frame to]: ', Math.floor(this.props.initFrame / 72 * (this.props.children.length || 1)))
          this.setCurrentFrame(Math.floor(this.props.initFrame / 72 * (this.props.children.length || 1)))
          //this.setCurrentFrame(Math.floor(this.props.children.length / 2))
          //console.log(Math.floor(this.props.children.length / 2), this.props.children.length)
          
          //}
          
          //this.setCurrentFrame(Math.floor(this.props.children.length / 2))
          
        } else if (this.props.initFrame !== -1){
          this.setCurrentFrame(Math.floor(this.props.initFrame / 72 * (this.props.children.length || 1)))
        }*/
      }
      
    }
  }

  componentWillUnmount () {

    /*longestSide = window.innerWidth > window.innerHeight ? window.innerWidth : window.innerHeight;
    shortestSide = window.innerWidth > window.innerHeight ? window.innerHeight : window.innerWidth;
    screenSize = [window.innerWidth, window.innerHeight];

    if(window.mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
      startLeftOffset = -25;
      barOffset = 10;
      screenSize = [longestSide * 0.5625, longestSide];
      imageSize = [longestSide * 0.84 * 1.777778, longestSide * 0.84];
    } else {
      imageSize = [longestSide, longestSide * 0.5625];
      barOffset = 0;
      startLeftOffset = 0;
      console.log('to landscape')
    }*/

    this._isMounted = false;

    document.removeEventListener('mouseup', this.touchEnd, false)
    this.stop()
  }


  handleUpdateViewer = () => {
    longestSide = window.innerWidth > window.innerHeight ? window.innerWidth : window.innerHeight;
    shortestSide = window.innerWidth > window.innerHeight ? window.innerHeight : window.innerWidth;
    screenSize = [window.innerWidth, window.innerHeight];

    if(window.mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
      startLeftOffset = -25;
      barOffset = 10;
      screenSize = [longestSide * 0.5625, longestSide];
      imageSize = [longestSide * 0.84 * 1.777778, longestSide * 0.84];
    } else {
      imageSize = [longestSide, longestSide * 0.5625];
      barOffset = 0;
      startLeftOffset = 0;
    }
  }

  setCurrentFrame (frame) {

    if(!this._isMounted){
      return;
    }
    
    const {cycle, children, onChange} = this.props
    const length = children.length
    let current = frame

    if (current < 0) {
      current = cycle ? length - 1: 0
    }

    if (current + Math.sign(this.state.speed) >= length - 1) {
      
      current = cycle ? current % (length || 1) : length - 1;
      if(!cycle){
        this.setState({
          speed: 0
        })
      }
      
    }

    if (current !== this.state.current) {
      this.setState({current})
            
      onChange(current)

    } else if (this.props.autoPlay) {
      this.stop()
    }
  }

  nextFrame () {
    const {current} = this.state
    const {reverse, autoPlay, pauseOnHover} = this.props
    const playTimeout = autoPlay === true ? 75 : autoPlay

    if (!this.hovered || !pauseOnHover) {
      this.setCurrentFrame(reverse ? current - 1 : current + 1)
    }

    this.nextTimeout = setTimeout(() => {
      this.nextFrame()
    }, playTimeout)
  }

  stop () {
    clearTimeout(this.nextTimeout)
  }

  hover = event => {
    this.hovered = true
  }

  unhover = event => {
    this.hovered = false
  }

  wheelMove = event => {

    // TODO: implement wheel zoom
    
  }

  touchStart = event => {
    if(!this._isMounted){
      return;
    }
    if(this.state.autoPlay){
      return;
    }
    event.preventDefault()
    this.pointerPosition = this.calculatePointerPosition(event)
    this.startFrame = this.state.current
    this.stop()

    if(event.type.indexOf('touch') === 0 && event.touches.length == 2){
      
      this.touchCenter = this.newTouchCenter = [Math.abs(event.touches[1].clientX + event.touches[0].clientX)/2, Math.abs(event.touches[1].clientY + event.touches[0].clientY)/2];
      
    }
  }

  touchMove = event => {
    if(!this._isMounted){
      return;
    }

    if(this.state.autoPlay){
      return;
    }

    const notTouched = typeof this.pointerPosition !== 'number'
    event.preventDefault()

    if (notTouched) {
      return
    }

    // multitouch
    if(event.type.indexOf('touch') === 0 && event.touches.length == 2){
      
      this.touchDistance = Math.sqrt(Math.pow(event.touches[1].clientX - event.touches[0].clientX, 2) + Math.pow(event.touches[1].clientY - event.touches[0].clientY, 2));
      
      // fixed zoom speed
      let zoom = this.newTouchDistance - this.touchDistance > 0 ? -0.050 : 0.010; 
            
      this.touchCenter = [Math.abs(event.touches[1].clientX + event.touches[0].clientX)/2, Math.abs(event.touches[1].clientY + event.touches[0].clientY)/2];
      
      this.updateZoomAndOffsets(zoom, this.touchCenter[0] - this.newTouchCenter[0], this.touchCenter[1] - this.newTouchCenter[1])
      
    } else {

      // spin

      const {vertical, children, reverse} = this.props
      
      const pointer = this.calculatePointerPosition(event)
      
      const offset = (pointer - this.pointerPosition) / 8
      
      // set speed based on pointer offset
  
      if(this.props.children.length === 12){
        this.setState(prevstate => ({
          acc: -(Math.sign(offset)) * .75,
          speed: -(Math.sign(offset)) * .75
        }))
      } else {
        this.setState(prevstate => ({
          acc: -Math.sign(offset) * Math.round(this.props.maxspeed / 2) / 10,
          speed: prevstate.speed + this.state.acc
        }))
      }
    
    }
    
    this.pointerPosition = this.calculatePointerPosition(event)
    this.startFrame = this.state.current
    
  }

  updateZoomAndOffsets = (zoom, leftOffset, topOffset) => {
    
    this.setState(prevState => {
      let tz = Math.min(2, Math.max(1, prevState.targetZoom + zoom))
      // set offset limits
      return {
        targetZoom: tz,
        targetLeftOffset: Math.min(Math.max(prevState.targetLeftOffset + leftOffset, -(1 - screenSize[0] / imageSize[0]) * 100 - (50 + 100 * (screenSize[0] - imageSize[0]) / imageSize[0]) * (prevState.targetZoom - 1) / 2 ), 25 * (prevState.targetZoom - 1)),
        targetTopOffset:  Math.min(Math.max(prevState.targetTopOffset + topOffset, - 12.5 * (prevState.targetZoom - 1) / 2 ), + 25 * (prevState.targetZoom - 1) / 2)
      }
    }/*,
    ()=> {
      console.log('lo:', this.state.leftOffset, 
      'lim:', -(1 - screenSize[0] / (imageSize[0])) * 100 + 25 * (this.state.targetZoom - 1) / 2, 
      '%:',25 * (this.state.targetZoom - 1))
    }*/)

    this.newTouchCenter = this.touchCenter;
    this.newTouchDistance = this.touchDistance;
  }

  touchEnd = event => {
    if(!this._isMounted){
      return;
    }
    if(this.state.autoPlay){
      return;
    }
    event.preventDefault()
    this.pointerPosition = null
    this.startFrame = null
  }

  pressKey = event => {
    const eventOnField = event.target.tagName.match('TEXTAREA|INPUT|SELECT')

    if (eventOnField) {
      return
    }

    const {current} = this.state
    const {vertical, reverse} = this.props
    const prevKey = vertical ? 38 : 37
    const nextKey = vertical ? 40 : 39
    this.stop()

    if (event.keyCode === prevKey) {
      this.setCurrentFrame(reverse ? current + 1 : current - 1)
    } else if (event.keyCode === nextKey) {
      this.setCurrentFrame(reverse ? current - 1 : current + 1)
    }
  }

  calculatePointerPosition (event) {
    const {clientX, clientY} = event.type.indexOf('touch') === 0 ? event.changedTouches[0] : event
    const {offsetTop, offsetLeft} = event.currentTarget
    return this.props.vertical ? clientY - offsetTop : clientX - offsetLeft
  }

  render () {

    if(!this._isMounted){
      return <div></div>;
    }

    const {current} = this.state

    const {
      children,
      className,
      tabIndex,
      scroll,
      pauseOnHover
    } = this.props

    return (
      <div
        tabIndex={tabIndex}
        /*onTouchStart={this.touchStart}
        onTouchMove={this.touchMove}
        onTouchEnd={this.touchEnd}
        onMouseDown={this.touchStart}
        onMouseMove={this.touchMove}*/
        onWheel={scroll ? this.wheelMove : null}
        onMouseEnter={pauseOnHover ? this.hover : null}
        onMouseLeave={pauseOnHover ? this.unhover : null}
        onKeyDown={tabIndex >= 0 ? this.pressKey : null}
        className={className}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          transform: 'scale('+this.state.zoom+') translate(' + this.state.leftOffset + '%, calc('+ barOffset + '% + ' + this.state.topOffset + '%))'
        }}
        id="rotation-controller"
        >        
        {Children.map(children, (child, i) => cloneElement(
          child,
          {
            style: {
              width: '100%',
              display: current === i ? 'block' : 'none',
              willChange: 'visibility'
            }
          }
        ))}
      </div>
    )
  }
}

Rotation.propTypes = {
  className: PropTypes.string,
  cycle: PropTypes.bool,
  speed: PropTypes.number,
  maxspeed: PropTypes.number,
  scroll: PropTypes.bool,
  vertical: PropTypes.bool,
  reverse: PropTypes.bool,
  autoPlay: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number
  ]),
  onChange: PropTypes.func,
  onRotationEnded: PropTypes.func,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  tabIndex: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  pauseOnHover: PropTypes.bool
}

Rotation.defaultProps = {
  cycle: false,
  speed: 1,
  maxspeed: 1,
  scroll: true,
  vertical: false,
  tabIndex: 0,
  autoPlay: false,
  pauseOnHover: false,    
  onChange: () => {},
  onRotationEnded: () => {}
}

export default Rotation;
